










import { Component, Vue, Prop } from 'vue-property-decorator';
import { mdbBtn, mdbIcon, mdbTooltip } from '@folky-tools/mdbvue';
import { BusinessFrontPageSummary } from '@/models/businesses/business-front-page-summary';

@Component({
    components: { mdbBtn, mdbIcon, mdbTooltip }
})
export default class FrontPageLinksToConsumers extends Vue {
    @Prop() private businessName!: string;
    @Prop(BusinessFrontPageSummary) private businessFrontPageSummary!: BusinessFrontPageSummary;

    private async mounted(): Promise<void> {
        this.businessFrontPageSummary.publicationStatus.forEach((consumer, index) => {
            if (consumer.isCanonical) {
                this.businessFrontPageSummary.publicationStatus.splice(index, 1);
                this.businessFrontPageSummary.publicationStatus.unshift(consumer);
            }
        });
        this.$emit('teaserCardLinksToConsumersLoaded');
    }

    private linkToConsumerTeaserCard(consumerId: number): string | undefined {
        const consumerPublicationStatus = this.businessFrontPageSummary.publicationStatus.find(ps => ps.consumerId === consumerId);

        if (!consumerPublicationStatus) {
            return undefined;
        }

        const linkToConsumerTeaserCard = consumerPublicationStatus.urlParts.some(urlPart => urlPart.culture === this.$i18n.locale)
            ? consumerPublicationStatus.urlParts.find(urlPart => urlPart.culture === this.$i18n.locale)
            : consumerPublicationStatus.urlParts.find(urlPart => urlPart.culture === this.$i18n.fallbackLocale);

        return consumerPublicationStatus.isPublished ? `${linkToConsumerTeaserCard!.urlForEntitiesWithoutSlug}?searchTerm=${this.businessName}#top` : undefined;
    }

    private showEditConsumerQrModal(consumerId: number, consumerName: string): void {
        this.$emit('showEditConsumerQrModal', consumerId, consumerName);
    }
}
